import { render, staticRenderFns } from "./GopNotification.vue?vue&type=template&id=25f598ec&scoped=true"
import script from "./GopNotification.vue?vue&type=script&lang=js"
export * from "./GopNotification.vue?vue&type=script&lang=js"
import style0 from "./GopNotification.vue?vue&type=style&index=0&id=25f598ec&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f598ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2326903440/src/bitbucket.org/Modis-ito/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25f598ec')) {
      api.createRecord('25f598ec', component.options)
    } else {
      api.reload('25f598ec', component.options)
    }
    module.hot.accept("./GopNotification.vue?vue&type=template&id=25f598ec&scoped=true", function () {
      api.rerender('25f598ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/gop-redesign/components/GopNotification.vue"
export default component.exports